import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import DeviceEdit from './DeviceEdit'

import { actionCreators } from '@/checkout-instore-legacy/native/actions'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

const mapStateToProps = (state) => ({
  device: state.native.nativeAppInfo.device,
  credentials: state.native.nativeAppInfo.credentials,
  appInfo: state.native.nativeAppInfo,
})

/* Facilitate tests */
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(DeviceEdit)
